import React, { ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import AdminOverWrappedLoader from 'admin/components/atoms/AdminOverWrappedLoader';
import { useSelector } from 'react-redux';
import AlertDialog from 'shared/components/molecules/AlertDialog';
import ConfirmDialog from 'shared/components/molecules/ConfirmDialog';
import InputDialog from 'shared/components/molecules/InputDialog';
import PfFooter from 'shared/components/molecules/PfFooter';
import ProgressPercentDialog from 'shared/components/molecules/ProgressPercentDialog';
import ProgressPercentNumberDialog from 'shared/components/molecules/ProgressPercentNumberDialog';
import styles from 'shared/styles/styles';
import styled from 'styled-components';
import PfAdminHeader from 'admin/components/molecules/PfAdminHeader';
import { authSelector } from 'admin/redux/slices/authSlice';
import { systemAdminSelector } from 'admin/redux/slices/systemSlice';
import { PfAdminSideMenu } from './PfAdminSideMenu';

interface PfAdminDocumentProps {
  children?: ReactNode;
}
/**
 * ページ全体
 */
const PfAdminDocument: React.FC<PfAdminDocumentProps> = (props) => {
  // -- redux preparations --
  const auth_state = useSelector(authSelector);
  const system_state = useSelector(systemAdminSelector);

  // -- render part --
  return auth_state.is_logged_in ? (
    <StyledDocument className='base' isloading={system_state.loading.isActive}>
      <PfAdminSideMenu />
      <Body>
        <PfAdminHeader />
        <Content>{props.children}</Content>
      </Body>
      <PfFooter />

      {system_state.loading.isActive && <AdminOverWrappedLoader />}
      <ProgressPercentDialog />
      <AlertDialog />
      <ConfirmDialog />
      <InputDialog />
      <ProgressPercentNumberDialog />
    </StyledDocument>
  ) : (
    <ConvRedirect to='/login' />
  );
};

const ConvRedirect: React.FC<{ to: string }> = (params) => {
  const url = window.location.href;
  const to = params.to + '?redirect=' + encodeURIComponent(url);
  return <Redirect to={to} />;
};

// -- styled components --
const StyledDocument = styled.div<{
  isloading: boolean;
}>`
  display: flex;
  position: relative;
  opacity: ${(params) => (params.isloading ? 0.6 : 1.0)};
  pointer-events: ${(params) => (params.isloading ? 'none' : 'all')};
  height: 100vh;
  width: 100vw;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - ${styles.sidemenu_width});
`;

const Content = styled.div`
  width: 100%;
  height: calc(100% - ${styles.topmenu_height} - ${styles.footer_height});
  padding-top: 1px;
  overflow: hidden;
`;

// -- finally export part --

export default PfAdminDocument;
